import React from "react";
import Page from "components/Page";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const GatewayList = lazyWithRetry(() => import("./GatewayList"));

export default () => (
  <Page>
    <GatewayList />
  </Page>
);
